<template>
    <div class="infoscreen list" @click="$core.f().skip" v-if="$store.getters.authorized">
        <h1 class="headline">Wer ist im Chat?</h1>
        <div :class="'userlist'+( isAdmin ? ' is-admin' : '' )">
            <div v-for="(item, index) in list" :key="index" class="list-item">
                <div class="basic-info" @click="toggleInfo( item.id )">
                    <div class="username" :style="'color:#'+item.color+';'">{{ item.username }}</div>
                    <div v-if="1 === item.level" class="member">
                        &nbsp;
                    </div>
                    <div v-if="5 === item.level" class="admin">
                        Admin
                    </div>
                    <div v-if="10 === item.level" class="webmaster">
                        Admin
                    </div>
                </div>
                <transition-group appear name="slide-fade" mode="out-in">
                    <div v-if="isAdmin && -1 < open.indexOf( item.id )" class="extended-info"
                         :key="'ext-info-'+item.id">
                        <div>&nbsp;</div>
                        <div><span class="name">{{ item.name }}</span></div>
                        <div><span class="email">{{ item.email }}</span></div>
                    </div>
                    <div v-if="isAdmin && -1 < open.indexOf( item.id )" class="more-info" :key="'more-info-'+item.id">
                        <div>&nbsp;</div>
                        <div>{{ item.app_version }}</div>
                        <div><span class="remoteIp">{{ item.ip_address }}</span><br/>
                            <span class="reverseDns">{{ item.host_address }}</span></div>
                    </div>
                </transition-group>
            </div>
        </div>
    </div>
    <div v-else>
        <h1 class="headline wobble">Wer ist im Chat?</h1>
        <p class="content full"><strong>Hier</strong> findest Du normalerweise eine Übersicht über alle angemeldeten Nutzerinnen und Nutzer auf <Lovepod/>, die zur Zeit im Chat sind.<br/><br/>
        Melde Dich an, um mehr zu sehen ;-)</p>
    </div>
</template>
<script>
export default {
    name: 'Chat',
    data()
    {
        return {
            list:    [],
            open:    [],
            isAdmin: false
        }
    },
    
    mounted()
    {
        this.refresh()
    },
    
    methods: {
        refresh()
        {
            
            this.$core.getClient()
                .request( {
                    method: 'users.getChattingUsersList'
                } )
                .then( response =>
                {
                    
                    this.list = response.result
                    if ( Array.isArray( response.result )
                         && response.result[ 0 ].email !== undefined ) {
                        this.isAdmin = true
                    }
                    
                } )
            
        },
        
        toggleInfo( id )
        {
            if ( -1 === this.open.indexOf( id ) ) {
                this.open.push( id )
            } else {
                this.$core.f().removeFromArray( this.open, id )
            }
        }
    }
}
</script>